module.exports = __webpack_public_path__ + "img/teeth-21.d5ebc762.png";